"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class RadioGroup extends _react.Component {
  state = {
    validationState: null
  };
  constructor(props) {
    super(props);
    if (!props.id) {
      throw new Error(`The prop 'id' is required to make RadioGroup accessible for users using assistive technologies such as screen readers. Check the render method of RadioGroup.`);
    }
  }
  _onValidationChange = validationState => {
    const {
      onInvalid
    } = this.props;
    this.setState({
      validationState
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  render() {
    const {
      className,
      id,
      children,
      name,
      label,
      required,
      disabled,
      error,
      onChange
    } = this.props;
    const {
      validationState
    } = this.state;
    const isValid = validationState ? validationState.valid : true;
    const classes = (0, _classnames.default)('RadioGroup', 'FormElement', {
      'FormElement-contains-error': !isValid
    }, className);
    return /*#__PURE__*/_react.default.createElement("fieldset", {
      className: classes,
      id: `RadioGroup-${id}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control-container",
      role: "radiogroup"
    }, label, _react.Children.map(children, (child, i) => {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        name,
        disabled,
        required,
        onChange,
        id: `${id}-item-${i}`,
        onValidationChange: this._onValidationChange
      });
    })), !isValid && error);
  }
}
exports.default = RadioGroup;